import { NavLink } from 'react-router-dom';

import './NavItem.css';

function NavItem(props) {
  return (
    <li className="navbar__item">
      <NavLink className="navbar__link" to={props.goTo}>
        {props.title}
      </NavLink>
    </li>
  );
}

export default NavItem;
